"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnqueueWeeklyMonitorReportsMessage = void 0;
const workerMessage_1 = require("./workerMessage");
const model_1 = require("../model");
class EnqueueWeeklyMonitorReportsMessage extends workerMessage_1.WorkerMessage {
    constructor() {
        super(model_1.QueueDefinitions.ENQUEUE_WEEKLY_MONITOR_REPORTS);
    }
}
exports.EnqueueWeeklyMonitorReportsMessage = EnqueueWeeklyMonitorReportsMessage;
